<template>
    <div class="addProp-box">
        <el-form
            :label-position="'top'"
            label-width="80px"
            ref="formProp1"
            :rules="formRule1"
            :model="formProp1"
        >
            <el-form-item prop="property_completed" :label="$t('addProperty.propCompleted')">
                <el-row :gutter="16" class="type-card">
                    <el-radio-group v-model="formProp1.property_completed">
                        <el-col :span="12">
                            <el-radio label="1" border>{{$t("addProperty.propCompleted_y")}}</el-radio>
                        </el-col>
                        <el-col :span="12">
                            <el-radio label="0" border>{{$t("addProperty.propCompleted_n")}}</el-radio>
                        </el-col>
                    </el-radio-group>
                </el-row>
            </el-form-item>
            <el-form-item
                prop="property_completed_date"
                :label="$t('addProperty.propCompletedDate')"
                v-if="formProp1.property_completed == '1'"
            >
                <el-radio-group v-model="formProp1.property_completed_date">
                    <el-row :gutter="16" class="type-card">
                        <el-col :span="12">
                            <el-radio label="1" border>{{$t("addProperty.propCompletedDate1")}}</el-radio>
                        </el-col>
                        <el-col :span="12">
                            <el-radio label="0" border>{{$t("addProperty.propCompletedDate2")}}</el-radio>
                        </el-col>
                    </el-row>
                </el-radio-group>
            </el-form-item>
            <el-form-item prop="country" :label="$t('addProperty.propLocation')">
                <el-select
                    v-model="formProp1.country"
                    value-key="code3"
                    filterable
                    :placeholder="$t('addProperty.propLocationPlaceholder')"
                >
                    <el-option
                        v-for="item in locations"
                        :key="item.code3"
                        :label="item.name"
                        :value="item"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="propertyType" :label="$t('addProperty.propType')">
                <el-radio-group v-model="formProp1.propertyType">
                    <el-row :gutter="16" class="type-card">
                        <el-col :span="12">
                            <el-radio label="3" class="type-card-item">
                                <h4>{{$t('addProperty.propTypeApart')}}</h4>
                            </el-radio>
                        </el-col>
                        <el-col :span="12">
                            <el-radio label="1" class="type-card-item">
                                <h4>{{$t('addProperty.propTypeHouse')}}</h4>
                            </el-radio>
                        </el-col>
                        <el-col :span="12">
                            <el-radio label="2" class="type-card-item">
                                <h4>{{$t('addProperty.propTypeTownhome')}}</h4>
                            </el-radio>
                        </el-col>
                        <el-col :span="12">
                            <el-radio label="4" class="type-card-item">
                                <h4>{{$t('addProperty.propTypeCommercial')}}</h4>
                            </el-radio>
                        </el-col>
                    </el-row>
                </el-radio-group>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="goToStep">{{$t('addProperty.next')}}</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import { Message } from "element-ui";
export default {
    name: "addProp1",
    props: ["nationalities"],
    data() {
        const $t = this.$t.bind(this);
        return {
            formRule1: {
                country: {
                    required: true,
                    message: $t("addProperty.countryError"),
                    trigger: ["blur", "change"]
                }
            },
            formProp1: {
                property_completed: "1",
                property_completed_date: "1",
                propertyType: "3",
                country: undefined
            },
            locations: []
        };
    },

    beforeMount() {
        this.processCountry(this.nationalities);
    },

    methods: {
        goToStep() {
            let params = this.$refs["formProp1"].model;
            this.$refs["formProp1"].validate(valid => {
                if (!valid) {
                    // this.triggerMessage("error", {
                    //     message: this.$t("addProperty.fieldsError")
                    // });
                } else {
                    this.$emit("goToStep", {
                        step: 2,
                        form: this.formProp1
                    });
                }
            });
        },

        triggerMessage(type, options) {
            options.duration = 6000;
            return Message[type](options);
        },

        processCountry(list) {
            let preProcess = list;
            for (const key in preProcess) {
                preProcess[key]["_countryCode"] = preProcess[key]["url"]
                    .split(/[/ ]+/)
                    .pop();
            }

            this.locations = preProcess;
        }
    },

    watch: {
        nationalities: {
            handler(newVal, oldVal) {
                // let preProcess = JSON.parse(JSON.stringify(newVal));
                let preProcess = newVal;
                for (const key in preProcess) {
                    preProcess[key]["_countryCode"] = preProcess[key]["url"]
                        .split(/[/ ]+/)
                        .pop();
                }
                this.locations = preProcess;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.addProp-box {
    .subtitle {
        font-family: GothamMedium;
        font-size: 16px;
        font-weight: 500;
        line-height: 1;
        color: #2e384d;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/account/addProp1.vue